import {Injectable} from '@angular/core';




import {Router, ActivatedRouteSnapshot} from "@angular/router";
import {Subject} from "rxjs";
import {Question, QuestionService} from "../../../../swaggerServices";
import {IQuestionWithScAndSg} from "./question/question.component";

@Injectable()
export class QuestionsResolver  {

  question: IQuestionWithScAndSg;
  $question: Subject<Question> = new Subject<Question>();

  constructor(private router: Router,
              private questionsService: QuestionService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const isNewQuestion = route.paramMap.get('id') === "new";
    const taxYr = Number(route.queryParams.taxYear);

    if (isNewQuestion) {
      const question: IQuestionWithScAndSg = {
        id: 0,
        question: null,
        mandatory: false,
        default: null,
        min: null,
        max: null,
        maxLength: null,
        hint: null,
        APSRef: null,
        APSSection: null,
        APSSubsection: null,
        APSQuestionGrouping: null,
        APSDimension: null,
        isCurrency: false,
        isPercentage: false,
        year: taxYr,
        displayFieldType: 'text',
        dataType: 'string',
        dependantMandatoryParentId: null,
        dependantMandatoryParentValue: null,
        questionDropdowns: [],
        lockMode: 'auto'
      };
      this.question = question;
      setTimeout(() => this.$question.next(this.question))

    } else {
      const id = Number(route.paramMap.get('id'));
      return this.fetch(id);
    }

  }

  getQuestionsObs() {
    return this.$question;
  }

  private fetch(id: number) {
    return this.questionsService.getquestionById(id).subscribe((data:any) => {
      this.question = data;
      this.$question.next(this.question);
      return data;
    });

  }

}
